module.exports = __webpack_public_path__ + "img/pdf-icon.a380dc43.svg";